import $ from 'jquery';

export default function onListItemHref() {
    let a = $(this).find('a');

    $(a).addClass('active');
    window.location = a[0].href;
}
